import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useAdditionalFiltersParameters } from './hooks';

type TAdBannerMicrofrontendAdditionalFiltersContainerProps = {
  manifest: IMicrofrontendManifest;
  /** Реклама отрисована — модалка снимает лоадер и показывает фильтры. */
  onLoad(): void;
  /** Рекламы нет / ошибка / баннер закрыт — модалка прячет блок с баннером. */
  onError(): void;
};

/**
 * Баннер в модалке «Все фильтры» на микрофронтенде ad-banner-frontend.
 *
 * Заглушку и закрытие баннера отдаём в onError: у модалки нет отдельной ветки под них,
 * а поведение то же — показать фильтры без баннера.
 */
export const AdBannerMicrofrontendAdditionalFiltersContainer: React.FC<
  TAdBannerMicrofrontendAdditionalFiltersContainerProps
> = ({ manifest, onLoad, onError }) => {
  const parameters = useAdditionalFiltersParameters();

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onLoad={onLoad}
      onStub={onError}
      onError={onError}
      onClose={onError}
    />
  );
};
